import { render, staticRenderFns } from "./innovativeResources.vue?vue&type=template&id=ba9da06a&scoped=true&"
import script from "./innovativeResources.vue?vue&type=script&lang=js&"
export * from "./innovativeResources.vue?vue&type=script&lang=js&"
import style0 from "./innovativeResources.vue?vue&type=style&index=0&id=ba9da06a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9da06a",
  null
  
)

export default component.exports